import { Typography } from '@workspace/ui/common';

export function NoResults({ children }: { children?: React.ReactNode }) {
  return (
    <Typography variant="bodyMd" className="text-sm md:text-base">
      {children ?? 'No results'}
    </Typography>
  );
}
